import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "btnContainer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Logg inn")

import { AuxButton } from '@ambita/design-system';
import { useMsal } from '@/composition-api/useMsal';
import { loginRequest } from '@/authConfig';

export default /*#__PURE__*/_defineComponent({
  __name: 'SignInButton',
  setup(__props) {

const { instance } = useMsal();

/*const loginPopup = () => {
  instance.loginPopup(loginRequest);
};*/

const loginRedirect = () => {
  instance.loginRedirect(loginRequest);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AuxButton), {
      primary: false,
      class: "btn",
      onClick: loginRedirect
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})